import type { PortType, WorkflowEdge, WorkflowNode } from "./types";

export function uid(prefix: string) {
  return `${prefix}_${Math.random().toString(16).slice(2)}_${Date.now().toString(16)}`;
}

export function canConnect(outputType: PortType, inputType: PortType) {
  if (inputType === "any" || outputType === "any") return true;
  // Pragmatic compatibility for early workflow building:
  // text/json can be coerced via stringify/parse in runtime adapters.
  if ((outputType === "text" && inputType === "json") || (outputType === "json" && inputType === "text")) return true;
  return outputType === inputType;
}

export function getPort(node: WorkflowNode, portId: string) {
  return [...node.data.inputs, ...node.data.outputs].find((p) => p.id === portId) ?? null;
}

export function edgeKey(e: Omit<WorkflowEdge, "id">) {
  return `${e.fromNodeId}:${e.fromPortId}->${e.toNodeId}:${e.toPortId}`;
}

export function hasSameEdge(edges: WorkflowEdge[], e: Omit<WorkflowEdge, "id">) {
  const key = edgeKey(e);
  return edges.some((x) => edgeKey(x) === key);
}

